import { theme } from '@/analyses/_shared/theme';
import { TIER_CONFIG, TIER_ORDER, type Tier } from '@/data/tiers';

export type LegendProps = {
  activeTier: Tier | null;
  onTierClick: (tier: Tier | null) => void;
  tierCounts: Record<Tier, number>;
};

export const Legend = ({ activeTier, onTierClick, tierCounts }: LegendProps) => (
  <div
    style={{
      display: 'flex',
      gap: 8,
      flexWrap: 'wrap',
      alignItems: 'center',
    }}
  >
    <span
      style={{
        color: theme.MUTED,
        fontSize: 10.5,
        textTransform: 'uppercase',
        letterSpacing: 0.7,
        fontWeight: 600,
        marginRight: 2,
      }}
    >
      Legend · click to filter
    </span>
    {TIER_ORDER.map((tier) => {
      const cfg = TIER_CONFIG[tier];
      const isActive = activeTier === tier;
      const count = tierCounts[tier];
      return (
        <button
          key={tier}
          onClick={() => onTierClick(isActive ? null : tier)}
          title={cfg.description}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 7,
            background: isActive ? `${cfg.color}22` : theme.CARD,
            border: `1px solid ${isActive ? cfg.color : theme.BORDER}`,
            borderRadius: 999,
            padding: '5px 12px',
            cursor: 'pointer',
            color: isActive ? cfg.color : theme.TEXT,
            fontSize: 12,
            fontWeight: 600,
            fontFamily: 'inherit',
            transition: 'all 0.15s',
          }}
        >
          <span
            style={{
              width: 9,
              height: 9,
              borderRadius: '50%',
              background: cfg.color,
              display: 'inline-block',
              boxShadow: isActive ? `0 0 0 2px ${cfg.color}44` : 'none',
            }}
          />
          {cfg.label}
          <span
            style={{
              color: theme.MUTED,
              fontWeight: 500,
              fontSize: 11,
            }}
          >
            {count}
          </span>
        </button>
      );
    })}
    {activeTier && (
      <button
        onClick={() => onTierClick(null)}
        style={{
          background: 'transparent',
          border: 'none',
          color: theme.BLUE_SOFT,
          fontSize: 11.5,
          cursor: 'pointer',
          textDecoration: 'underline',
          fontFamily: 'inherit',
          fontWeight: 500,
        }}
      >
        Clear filter
      </button>
    )}
  </div>
);
